import React, { useState } from "react";
import {
  TextField,
  Box,
  IconButton,
  Button,
} from "@mui/material";
import { TimeClock } from "@mui/x-date-pickers/TimeClock";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const TimeClockWithTextField = ({ label, value, onChange }) => {
  const [isClockVisible, setIsClockVisible] = useState(false); // State to control TimeClock visibility
  const parsedTime = value ? dayjs(value, "hh:mm A") : null;
  const [selectedTime, setSelectedTime] = useState(parsedTime); // Local state for selected time

  // Handle time change in the TimeClock
  const handleTimeChange = (newTime) => {
    setSelectedTime(newTime); // Update local state with the new time
  };

  // Confirm the selected time when the "OK" button is clicked
  const handleConfirm = () => {
    if (selectedTime && selectedTime.isValid()) {
      const formattedTime = selectedTime.format("hh:mm A"); // Format time as hh:mm A
      onChange(formattedTime); // Pass the formatted time to the parent component
      setIsClockVisible(false); // Hide the TimeClock
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ position: "relative", width: "100%" }}>
        {/* TextField with Clock Icon */}
        <TextField
          sx={{
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ff6b6b', // Custom hover color (Indian red)
              borderWidth: '2px',     // Optional: thicker border on hover
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#c70039', // Focused state color (darker red)
            },
          }}
          fullWidth
          label={label}
          value={value || ""} // Display the formatted time or an empty string
          InputProps={{
            readOnly: true, // Make TextField read-only
            endAdornment: (
              <IconButton
                onClick={() => setIsClockVisible(true)} // Show TimeClock on icon click
                edge="end"
              >
                <AccessTimeIcon />
              </IconButton>
            ),
          }}
        />

        {/* TimeClock (shown conditionally) */}
        {isClockVisible && (
          <Box
            sx={{
              position: "absolute",
              top: "100%", // Position below the TextField
              left: 0,
              zIndex: 1000,
              backgroundColor: "#fff",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              borderRadius: 0.5,
              padding: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TimeClock
              value={selectedTime}
              ampm={true} // Enable 12-hour clock with AM/PM
              onChange={handleTimeChange}
            />
            {/* OK Button */}
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirm}
              sx={{ mt: 2 }}
            >
              OK
            </Button>
          </Box>
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default TimeClockWithTextField;